export const VENDAS_HISTORICO = [
  { ano: 2020, mes: 4,  valor: 3744 },
  { ano: 2020, mes: 5,  valor: 28908 },
  { ano: 2020, mes: 6,  valor: 41135 },
  { ano: 2020, mes: 7,  valor: 46387 },
  { ano: 2020, mes: 8,  valor: 55027 },
  { ano: 2020, mes: 9,  valor: 52755 },
  { ano: 2020, mes: 10, valor: 50410 },
  { ano: 2020, mes: 11, valor: 70121 },
  { ano: 2020, mes: 12, valor: 26222 },
  { ano: 2021, mes: 1,  valor: 55748 },
  { ano: 2021, mes: 2,  valor: 40553 },
  { ano: 2021, mes: 3,  valor: 70724 },
  { ano: 2021, mes: 4,  valor: 55075 },
  { ano: 2021, mes: 5,  valor: 102226 },
  { ano: 2021, mes: 6,  valor: 62770 },
  { ano: 2021, mes: 7,  valor: 77350 },
  { ano: 2021, mes: 8,  valor: 81665 },
  { ano: 2021, mes: 9,  valor: 71350 },
  { ano: 2021, mes: 10, valor: 77023 },
  { ano: 2021, mes: 11, valor: 88500 },
  { ano: 2021, mes: 12, valor: 54000 },
  { ano: 2022, mes: 1,  valor: 81438 },
  { ano: 2022, mes: 2,  valor: 85000 },
  { ano: 2022, mes: 3,  valor: 85000 },
  { ano: 2022, mes: 4,  valor: 80000 },
  { ano: 2022, mes: 5,  valor: 80000 },
  { ano: 2022, mes: 6,  valor: 105556 },
  { ano: 2022, mes: 7,  valor: 139000 },
  { ano: 2022, mes: 8,  valor: 130000 },
  { ano: 2022, mes: 9,  valor: 125300 },
  { ano: 2022, mes: 10, valor: 120810 },
  { ano: 2022, mes: 11, valor: 170000 },
  { ano: 2022, mes: 12, valor: 127000 },
  { ano: 2023, mes: 1,  valor: 143840 },
  { ano: 2023, mes: 2,  valor: 124100 },
  { ano: 2023, mes: 3,  valor: 157037 },
  { ano: 2023, mes: 4,  valor: 101665 },
  { ano: 2023, mes: 5,  valor: 161110 },
  { ano: 2023, mes: 6,  valor: 140090 },
  { ano: 2023, mes: 7,  valor: 155100 },
  { ano: 2023, mes: 8,  valor: 204000 },
  { ano: 2023, mes: 9,  valor: 171875 },
  { ano: 2023, mes: 10, valor: 171954 },
  { ano: 2023, mes: 11, valor: 205721 },
  { ano: 2023, mes: 12, valor: 147861 },
  { ano: 2024, mes: 1,  valor: 226801.60 },
  { ano: 2024, mes: 2,  valor: 182711 },
  { ano: 2024, mes: 3,  valor: 254952 },
  { ano: 2024, mes: 4,  valor: 180868 },
  { ano: 2024, mes: 5,  valor: 256222 },
  { ano: 2024, mes: 6,  valor: 177325 },
  { ano: 2024, mes: 7,  valor: 262697.40 },
  { ano: 2024, mes: 8,  valor: 263000.10 },
  { ano: 2024, mes: 9,  valor: 232434.10 },
  { ano: 2024, mes: 10, valor: 288199.40 },
  { ano: 2024, mes: 11, valor: 358431 },
  { ano: 2024, mes: 12, valor: 192966.20 },
  { ano: 2025, mes: 1,  valor: 262824.20 },
  { ano: 2025, mes: 2,  valor: 265315 },
  { ano: 2025, mes: 3,  valor: 274189.80 },
  { ano: 2025, mes: 4,  valor: 243966.40 },
  { ano: 2025, mes: 5,  valor: 281800 },
  { ano: 2025, mes: 6,  valor: 193129 },
  { ano: 2025, mes: 7,  valor: 216298 },
  { ano: 2025, mes: 8,  valor: 180463 },
  { ano: 2025, mes: 9,  valor: 187371 },
  { ano: 2025, mes: 10, valor: 193000 },
  { ano: 2025, mes: 11, valor: 210000 },
  { ano: 2025, mes: 12, valor: 158357 },
  { ano: 2026, mes: 1,  valor: 147721 },
  { ano: 2026, mes: 2,  valor: 159730 },
  { ano: 2026, mes: 3,  valor: 221086 },
  { ano: 2026, mes: 4,  valor: 138254.90 },
  { ano: 2026, mes: 5,  valor: 147645 },
  { ano: 2026, mes: 6,  valor: 155616 },
  { ano: 2026, mes: 7,  valor: 207257.60 },
]

export const MESES = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez']

export const ANOS = [...new Set(VENDAS_HISTORICO.map(v => v.ano))].sort()
